/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { baseRequest } from './baseRequest';
const baseRoute = '/api/internal/eclose/ops';
const getRequestHeaders = tenant => ({
  'blend-api-version': '3.3.0',
  'blend-target-instance': tenant
});
export const sendENoteSigningEmails = async (closingId, tenant) => {
  return (await baseRequest.post(`${baseRoute}/closings/${closingId}/e-note/send-signing-link-emails`, {}, {
    headers: getRequestHeaders(tenant)
  })).data;
};